import { atom } from 'jotai';
import { ReactNode } from 'react';
import { atomWithReset } from 'jotai/utils';

import { ButtonMode, LogoAtomType, PageConstant, ButtonsObjectType } from 'src/types/app-bar';

export const logoAtom = atomWithReset<LogoAtomType>({
  type: 'image',
  value: 'default',
});

export const title = atom<string>('');

export const isCustomAppbar = atom<boolean>(false);
export const isCustomDesktopAppbar = atom<boolean>(false);
export const isSetDesktopMaxWidth = atom<boolean>(false);
export const leftBtnMode = atomWithReset<ButtonMode | null>(null);
export const rightBtnMode = atomWithReset<ButtonMode | null>(null);
export const leftBtnDisabled = atom<boolean>(false);
export const rightBtnDisabled = atom<boolean>(false);
export const rightBtnIcon = atom<ReactNode>(null);
export const customComponent = atom<React.ReactNode>(null);

export const isSearchOpen = atom<boolean>(false);
export const isRecentSearchOpen = atom<boolean>(false);
export const searchPlaceholder = atom<string>('learner.1452');

export const isSearchInMobileMode = atomWithReset<boolean>(false);

export const search = atom<string>('');

export const debouncedSearch = atom<string>('');

export const leftBtnMethod = atom<{ fn: () => any }>({
  fn: () => {},
});

// Source: https://github.com/pmndrs/jotai/discussions/1746#discussioncomment-4872129
export const setLeftBtnMethod = atom(
  (get) => get(leftBtnMethod),
  (get, set, newFn: () => any) => {
    set(leftBtnMethod, { fn: newFn });
  }
);

export const rightBtnMethod = atom<{ fn: () => any }>({
  fn: () => {},
});

export const setRightBtnMethod = atom(
  (get) => get(rightBtnMethod),
  (get, set, newFn: () => any) => {
    set(rightBtnMethod, { fn: newFn });
  }
);
export const titleButton = atom('');
export const submittedSearchTerms = atom('');

export const currentPage = atomWithReset<PageConstant | ''>('');

export const searchTermUpdateTrigger = atomWithReset(0);

export type SeachProps = {
  uri: string;
  searchValue: string;
};

export const searchAtom = atom<SeachProps>({
  uri: '',
  searchValue: '',
});

export const isAppbarDisabled = atom<boolean>(false);

export const isAppbarWithMultiButtonsAtom = atom<boolean>(false);

export const buttonsObjectAtom = atom<ButtonsObjectType[]>([]);

// TASK-295: 홈 앱 전환 유도 Alert 가시 상태 (본문 marginTop 오프셋 계산용)
export const homeAppInstallAlertVisible = atom<boolean>(false);
